export type TaskFilter={search:string;area:string;scope:string;participant:string;status:string;due:string};
type SearchTask={title:string;description:string;scope:string;status:string;owner_user_id:string;partner_user_id:string|null;responsible_user_id?:string|null;external_owner_name?:string;due_at:string|null;personal?:{inbox?:number;area_id:string|null;next_action:string|null}};
export function matchesTask(task:SearchTask,filter:TaskFilter,day:string){
 if(filter.scope!=="all"&&task.scope!==filter.scope)return false;
 if(filter.participant){
  if(filter.participant.startsWith("external:")){if(task.external_owner_name!==filter.participant.slice(9))return false;}
  else if(task.owner_user_id!==filter.participant&&task.partner_user_id!==filter.participant&&task.responsible_user_id!==filter.participant)return false;
 }
 if(filter.area&&(filter.area==="__none__"?Boolean(task.personal?.area_id):task.personal?.area_id!==filter.area))return false;
 if(filter.status==="open"&&["completed","archived"].includes(task.status))return false;
 if(filter.status==="inbox"&&!task.personal?.inbox)return false;
 if(!["all","any","open","inbox"].includes(filter.status)&&task.status!==filter.status)return false;
 const due=task.due_at;
 if(filter.due==="none"&&due)return false;
 if(filter.due==="today"&&due!==day)return false;
 if(filter.due==="overdue"&&(!due||due>=day||["completed","archived"].includes(task.status)))return false;
 if(filter.due==="upcoming"&&(!due||due<=day))return false;
 if(filter.due==="next7"){
  const end=new Date(day+"T12:00:00Z");end.setUTCDate(end.getUTCDate()+7);
  if(!due||due<day||due>=end.toISOString().slice(0,10))return false;
 }
 return !filter.search||[task.title,task.description,task.personal?.next_action,task.external_owner_name].join(" ").toLocaleLowerCase("de").includes(filter.search.trim().toLocaleLowerCase("de"));
}
